(function(){
"use strict";

/* ---------- data ---------- */
var P=[
 {id:"rio",name:"Rio",v50:64767128961401,coords:"22.91\u00B0 S / 43.17\u00B0 W",cat:"For him",price:30,iw:457,ih:950,
  family:"Citrus Amber Woody",
  plain:"The citrus one. Bright, zesty, uplifting",
  top:"Bergamot, citrus peel, mandarin, orange",heart:"Tropical fruits, aromatic woods, soft florals",base:"Amber, tonka, vanilla, smooth woods, musk",
  occ:["Daytime","Summer","Holidays"],
  desc:"A bright, energetic citrus inspired by sun-drenched coastlines. Bergamot, mandarin and citrus peel open sparkling and uplifting, before tropical woods, tonka and amber warm the finish.",
  story:"Rio is the window-down, sun-on-your-face scent: the one that turns an ordinary Tuesday into a holiday. Spray it and walk out lighter."},
 {id:"milano",name:"Milano",v50:64767129026937,coords:"45.46\u00B0 N / 9.19\u00B0 E",cat:"For him",price:30,iw:447,ih:952,
  family:"Fresh Fruity Aromatic \u00B7 Clean Luxury",
  plain:"The clean one. Fresh, everyday, polished",
  top:"Fresh citrus, crisp fruits, bergamot, green accords",heart:"Juicy tropical fruits, smooth florals, clean aromatics",base:"Amber, musk, light woods, subtle vanilla",
  occ:["Every day","The office","Your signature"],
  desc:"Built on freshness and effortless confidence. Clean citrus and crisp fruit open bright, giving way to a smooth aromatic heart; soft woods, amber and musk leave a polished, modern finish.",
  story:"Milano is the one you reach for without thinking: the scent that makes you smell clean, expensive and put together before you have said a word. Your everyday armour."},
 {id:"paname",name:"Paname",v50:64767129059705,coords:"48.86\u00B0 N / 2.35\u00B0 E",cat:"For her",price:30,iw:443,ih:949,
  family:"Amber \u00B7 Sweet Vanilla Oriental",
  plain:"The vanilla one. Warm, sweet, indulgent",
  top:"Warm vanilla, soft amber, light fruit, golden caramel",heart:"Rich vanilla, creamy florals, benzoin, sweet resins",base:"Brown sugar, tonka, amber, soft musk, warm woods",
  occ:["Date night","Cold evenings","Cosy nights in"],
  desc:"A luxurious vanilla amber built on warmth and sweetness. A smooth golden opening melts into a rich, creamy vanilla heart. Like melted amber, soft spices and freshly made vanilla.",
  story:"Paname is the scent you wear close: warm vanilla that wraps around you like cashmere. Made for slow evenings and the people you let get close enough to notice."},
 {id:"havana",name:"Havana",v50:64767129125241,coords:"23.11\u00B0 N / 82.36\u00B0 W",cat:"For her",price:30,iw:460,ih:949,
  family:"Fruity \u00B7 Sweet Floral Amber",
  plain:"The fruity one. Juicy berries, soft florals",
  top:"Juicy berries, sweet fruits, soft citrus, creamy fruit",heart:"Floral sweetness, strawberry, soft vanilla, delicate florals",base:"Vanilla, amber, musk, soft woods, warm sweetness",
  occ:["Nights out","Spring days","Celebrations"],
  desc:"A playful, fruity scent that captures a tropical sunset. Juicy berries and sweet fruit burst open before melting into a soft floral heart wrapped in creamy vanilla.",
  story:"Havana is the flirt of the collection: juicy, sweet and made to be asked about. Wear it on the nights you want to be remembered, and let the compliments come to you."},
 {id:"monaco",name:"Monaco",v50:64767129616761,coords:"43.73\u00B0 N / 7.42\u00B0 E",cat:"The Reserve",price:40,badge:"Reserve",iw:470,ih:945,
  family:"Amber Woody Gourmand \u00B7 Oud Vanilla",
  plain:"The oud one. Creamy vanilla, dark woods",
  top:"Warm vanilla, soft spices, sweet amber, golden sweetness",heart:"Rich oud, creamy vanilla orchid, benzoin warmth, woody depth",base:"Dark oud wood, tonka, brown sugar, amber, soft musk",
  occ:["Black tie","Winter nights","High stakes"],
  desc:"Creamy vanilla meets deep oriental wood. A rich, golden sweetness opens before a sophisticated oud heart brings depth and mystery, settling into dark oud wrapped in velvety vanilla.",
  story:"Monaco is for the nights when the stakes are high and you intend to win. Dark oud, golden vanilla, and confidence that enters the room a step before you do."},
 {id:"casablanca",name:"Casablanca",v50:64767129682297,coords:"33.57\u00B0 N / 7.59\u00B0 W",cat:"The Reserve",price:40,badge:"Reserve",iw:450,ih:952,
  family:"Amber Gourmand",
  plain:"The gourmand one. Cake, spice, golden vanilla",
  top:"Sparkling mandarin, sweet bergamot, lavender, cardamom",heart:"Warm cinnamon, benzoin, creamy orange blossom, caramel",base:"Vanilla bean, tonka, amber, sandalwood, smooth musk",
  occ:["Dinner dates","Cold evenings","Compliments"],
  desc:"An indulgent amber gourmand. Sparkling mandarin and bergamot open bright before warm cinnamon and caramel unfold into creamy vanilla, tonka and amber: a golden, cake-like warmth that feels comforting and composed.",
  story:"Casablanca is the compliment magnet of the house: warm sponge, golden spice and praline you can wear. Save it for long dinners and cold evenings, then get used to strangers asking what it is."}
];
var PAIRS={rio:"milano",milano:"rio",paname:"havana",havana:"paname",monaco:"casablanca",casablanca:"monaco"};
function byId(id){for(var i=0;i<P.length;i++){if(P[i].id===id)return P[i];}return P[0];}
function money(n){return "£"+n.toFixed(2);}
/* cart data comes from /cart.js and is customer-controllable: only accept _duo values in the format addDuoToCart() creates, and escape anything put into HTML */
function validDuo(v){return (typeof v==="string"&&/^duo-\d{1,16}$/.test(v))?v:null;}
function esc(s){return String(s).replace(/[&<>"']/g,function(c){return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c];});}
function imgUrl(id){return (window.BB_ASSETS||{})[id]||"";}
function img2Url(){return (window.BB_ASSETS||{}).product2||"";}

/* ---------- LAUNCH SWITCH ----------
   true  = buy buttons add to the Shopify cart and checkout goes to Shopify's real checkout.
   false = preview mode: every buy button is relabelled (buyLabel) and, when tapped,
           shows the launch message and goes to the early-access signup (launchNotice)
           without calling Shopify. Products should also stay Draft while this is false. */
var CHECKOUT_ENABLED = true;
var LAUNCH_MSG = "Ordering opens Saturday 17 October. Join early access to hear first ✦";
function buyLabel(live, preview){return CHECKOUT_ENABLED ? live : (preview || "Opens 17 Oct");}

/* ---------- Shopify cart connection ---------- */
var VARIANT_INFO={};
(function(){
 for(var i=0;i<P.length;i++){
  VARIANT_INFO[P[i].v50]={id:P[i].id,size:"50ml"};
 }
})();
var shopifyCart=null;
function cartFetch(){
 return fetch("/cart.js",{headers:{"Accept":"application/json"}}).then(function(r){return r.json();}).then(function(c){shopifyCart=c;return c;});
}
function cartAddItems(items){
 return fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify({items:items})})
  .then(function(r){ if(!r.ok){return r.json().then(function(e){throw new Error(e.description||"cart add failed");});} return r.json(); })
  .then(function(){return cartFetch();});
}
function cartChangeByKey(key,quantity){
 return fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify({id:key,quantity:quantity})})
  .then(function(r){ if(!r.ok){return r.json().then(function(e){throw new Error(e.description||"cart change failed");});} return r.json(); })
  .then(function(){return cartFetch();});
}
function cartUpdateKeys(updatesObj){
 return fetch("/cart/update.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify({updates:updatesObj})})
  .then(function(r){ if(!r.ok){return r.json().then(function(e){throw new Error(e.description||"cart update failed");});} return r.json(); })
  .then(function(){return cartFetch();});
}
function cartLinesInfo(){
 var lines=(shopifyCart&&shopifyCart.items)||[];
 return lines.map(function(line){
  var info=VARIANT_INFO[line.variant_id]||{};
  return {
   key:line.key,variantId:line.variant_id,qty:line.quantity,
   fragId:info.id,title:line.product_title||line.title||"Item",
   duoGroup:validDuo(line.properties&&line.properties._duo),
   finalLinePrice:line.final_line_price,originalLinePrice:line.original_line_price
  };
 });
}

/* ---------- duo pricing (preview display only — see duoTier()/duoWas() below; real cart math/discounts come from Shopify, see cartLinesInfo() further down) ---------- */
var DUO_TIERS=[{price:50,save:10},{price:55,save:15},{price:60,save:20}];
function duoTier(idA,idB){
 var a=byId(idA),b=byId(idB);
 var n=(a.cat==="The Reserve"?1:0)+(b.cat==="The Reserve"?1:0);
 return DUO_TIERS[n];
}
function duoWas(idA,idB){return byId(idA).price+byId(idB).price;}

/* ---------- svg builders (official bottle) ---------- */
var UID=0;
function bottleSVG(cls){
 UID++;var g="g"+UID,t="t"+UID,x="x"+UID;
 var s='<svg class="'+(cls||"bottle")+'" viewBox="0 0 200 340" role="img" aria-label="BuiltByThree bottle">';
 s+='<defs>';
 s+='<linearGradient id="'+g+'" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#EFCF7F"/><stop offset=".5" stop-color="#C69A44"/><stop offset="1" stop-color="#8F6B25"/></linearGradient>';
 s+='<linearGradient id="'+x+'" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#0A0908"/><stop offset=".42" stop-color="#0F0D0B"/><stop offset=".62" stop-color="#161310"/><stop offset=".78" stop-color="#241E18" stop-opacity=".85"/><stop offset=".9" stop-color="#B9B2A4" stop-opacity=".22"/><stop offset="1" stop-color="#E4DFD2" stop-opacity=".14"/></linearGradient>';
 s+='<pattern id="'+t+'" width="6" height="6" patternUnits="userSpaceOnUse" patternTransform="rotate(45)"><rect width="6" height="6" fill="#15120F"/><line x1="0" y1="0" x2="0" y2="6" stroke="rgba(201,178,131,.16)" stroke-width="1.1"/></pattern>';
 s+='</defs>';
 s+='<rect x="64" y="6" width="72" height="8" rx="3" fill="url(#'+g+')"/>';
 s+='<rect x="64" y="14" width="72" height="46" fill="url(#'+t+')" stroke="rgba(0,0,0,.45)"/>';
 s+='<rect x="64" y="60" width="72" height="9" fill="url(#'+g+')"/>';
 s+='<rect x="74" y="69" width="52" height="13" fill="url(#'+g+')" opacity=".92"/>';
 s+='<path d="M66 84 H134 L154 104 V300 L140 318 H60 L46 300 V104 Z" fill="url(#'+x+')" stroke="rgba(255,255,255,.07)"/>';
 s+='<path d="M52 288 H148 L140 312 H60 Z" fill="rgba(240,236,226,.12)"/>';
 s+='<rect x="52" y="104" width="7" height="172" rx="3.5" fill="rgba(255,255,255,.13)"/>';
 s+='<rect x="141" y="112" width="4" height="150" rx="2" fill="rgba(255,255,255,.07)"/>';
 s+='<g fill="url(#'+g+')"><g transform="scale(-1,1)"><text x="-91" y="176" text-anchor="middle" font-family="Hanken Grotesk,sans-serif" font-weight="600" font-size="46" letter-spacing="0">B</text></g><text x="109" y="176" text-anchor="middle" font-family="Hanken Grotesk,sans-serif" font-weight="600" font-size="46" letter-spacing="0">B</text></g>';
 s+='<text x="100" y="252" text-anchor="middle" font-family="Marcellus,serif" font-size="10.5" letter-spacing=".6" fill="url(#'+g+')">Extrait de Parfum</text>';
 s+='</svg>';
 return s;
}
function boxSVG(p){
 UID++;var g="g"+UID;
 var s='<svg class="boxart" viewBox="0 0 200 320" role="img" aria-label="'+p.name+' presentation box">';
 s+='<defs><linearGradient id="'+g+'" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#EFCF7F"/><stop offset=".5" stop-color="#C69A44"/><stop offset="1" stop-color="#8F6B25"/></linearGradient></defs>';
 s+='<rect x="36" y="28" width="128" height="264" rx="4" fill="#101218"/>';
 s+='<rect x="36" y="28" width="10" height="264" rx="4" fill="#1A1D26"/>';
 s+='<g fill="url(#'+g+')"><g transform="scale(-1,1)"><text x="-93" y="120" text-anchor="middle" font-family="Hanken Grotesk,sans-serif" font-weight="600" font-size="34">B</text></g><text x="107" y="120" text-anchor="middle" font-family="Hanken Grotesk,sans-serif" font-weight="600" font-size="34">B</text></g>';
 s+='<text x="100" y="146" text-anchor="middle" font-family="Marcellus,serif" font-size="13" letter-spacing=".5" fill="url(#'+g+')">BuiltByThree</text>';
 s+='<text x="100" y="250" text-anchor="middle" font-family="Marcellus,serif" font-size="10" fill="url(#'+g+')">Extrait</text>';
 s+='<text x="100" y="266" text-anchor="middle" font-family="Hanken Grotesk,sans-serif" font-size="8" letter-spacing="1" fill="#B8B0A0">50 ml · '+p.name.toUpperCase()+'</text>';
 s+='</svg>';
 return s;
}
function detailSVG(p){
 UID++;var g="g"+UID;
 var s='<svg viewBox="0 0 200 320" role="img" aria-label="'+p.name+' details">';
 s+='<defs><linearGradient id="'+g+'" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#D9B15F"/><stop offset="1" stop-color="#9A7530"/></linearGradient></defs>';
 s+='<rect x="0" y="0" width="200" height="320" fill="#F8F6F0"/>';
 s+='<rect x="16" y="16" width="168" height="288" fill="none" stroke="#A0824A" stroke-width="1"/>';
 s+='<g fill="url(#'+g+')"><g transform="scale(-1,1)"><text x="-88" y="140" text-anchor="middle" font-family="Hanken Grotesk,sans-serif" font-weight="600" font-size="52">B</text></g><text x="112" y="140" text-anchor="middle" font-family="Hanken Grotesk,sans-serif" font-weight="600" font-size="52">B</text></g>';
 s+='<text x="100" y="176" text-anchor="middle" font-family="Marcellus,serif" font-size="15" letter-spacing="2" fill="#15130F">'+p.name.toUpperCase()+'</text>';
 s+='<text x="100" y="198" text-anchor="middle" font-family="Hanken Grotesk,sans-serif" font-size="8.5" letter-spacing="2.5" fill="#5E5749">'+p.coords.toUpperCase()+'</text>';
 s+='<text x="100" y="224" text-anchor="middle" font-family="Hanken Grotesk,sans-serif" font-size="7" letter-spacing="1.6" fill="#877F71">EXTRAIT STRENGTH</text>';
 s+='<text x="100" y="238" text-anchor="middle" font-family="Hanken Grotesk,sans-serif" font-size="7" letter-spacing="1.6" fill="#877F71">MACERATED TO PERFECTION</text>';
 s+='</svg>';
 return s;
}

/* ---------- state ---------- */
var wish={},recent=[],qty=1,current=null,drawerMode="cart",curFilter="all",galArr=[],galIx=0,duoSel=[],homeScrollY=0;

function $(s){return document.querySelector(s);}
function $all(s){return document.querySelectorAll(s);}

/* ---------- cards ---------- */
function cardHTML(p){
 var h='<article class="card reveal in" data-card="'+p.id+'">';
 h+='<button class="iconbtn wish'+(wish[p.id]?" on":"")+'" data-wish="'+p.id+'" aria-label="Toggle wishlist for '+p.name+'"><svg viewBox="0 0 24 24"><path d="M12 20s-7-4.5-9.2-8.6C1.2 8.4 3 5 6.4 5c2 0 3.6 1.1 4.6 2.7h2C14 6.1 15.6 5 17.6 5 21 5 22.8 8.4 21.2 11.4 19 15.5 12 20 12 20Z"/></svg></button>';
 if(p.badge){h+='<span class="badge">'+p.badge+'</span>';}
 h+='<a class="card-media" href="#" data-open="'+p.id+'"><img src="'+imgUrl(p.id)+'" alt="BuiltByThree '+p.name+' 50ml extrait de parfum bottle" width="'+p.iw+'" height="'+p.ih+'" loading="lazy"></a>';
 h+='<div class="card-body"><p class="coords">'+p.coords+'</p>';
 h+='<h3 class="card-name"><a href="#" data-open="'+p.id+'">'+p.name+'</a></h3>';
 h+='<p class="fam">'+p.plain+'</p>';
 h+='<div class="chips"><span class="chip">'+p.cat+'</span><span class="chip">'+p.occ[0]+'</span></div>';
 h+='<div class="card-row"><span class="price">'+money(p.price)+'</span><button class="btn btn-sm" data-add="'+p.id+'">'+buyLabel("Add to cart")+'</button></div>';
 h+='</div></article>';
 return h;
}
function renderGrid(el,list){var h="";for(var i=0;i<list.length;i++){h+=cardHTML(list[i]);}el.innerHTML=h;}
function applyFilter(f){
 curFilter=f;
 $all("#pills .pill").forEach(function(b){b.classList.toggle("on",b.getAttribute("data-filter")===f);});
 renderGrid($("#prodGrid"),P.filter(function(p){return f==="all"||p.cat===f;}));
}

/* ---------- initial paint ---------- */
applyFilter("all");

var mq="",i;
var mqItems=["A NEW ERA OF FRAGRANCE","LEAVE A TRACE"];
for(i=0;i<P.length;i++){mqItems.push(P[i].name.toUpperCase()+" — "+P[i].coords);}
for(var r=0;r<2;r++){for(i=0;i<mqItems.length;i++){mq+='<span><i>✦</i>'+mqItems[i]+'</span>';}}
$("#mqTrack").innerHTML=mq;

var megaH="",footH="";
for(i=0;i<P.length;i++){
 megaH+='<a href="#" data-open="'+P[i].id+'">'+P[i].name+'<span>'+money(P[i].price)+'</span></a>';
 footH+='<a href="#" data-open="'+P[i].id+'">'+P[i].name+'</a>';
}
$("#megaList").innerHTML=megaH;
$("#footShop").innerHTML=footH;

/* announcement rotation */
var annMsgs=[
 '<b>Build your Duo</b> — pair two different fragrances from £50. <a href="#duo" data-goto="duo">Build yours</a>',
 '<b>UK delivery</b> — £2.99 flat rate on every order · Small-batch, made in the UK',
 '<b>The Reserve</b>: Monaco &amp; Casablanca. <a href="#best" data-cat="The Reserve">Explore</a>'
];
var annI=0,annEl=$("#annMsg");
if(!window.matchMedia("(prefers-reduced-motion: reduce)").matches){
 setInterval(function(){
  annEl.style.opacity=0;
  setTimeout(function(){annI=(annI+1)%annMsgs.length;annEl.innerHTML=annMsgs[annI];annEl.style.opacity=1;},420);
 },6000);
}

/* ---------- toast ---------- */
var toastT;
function toast(msg){var t=$("#toast");t.textContent=msg;t.classList.add("on");clearTimeout(toastT);toastT=setTimeout(function(){t.classList.remove("on");},2600);}

/* ---------- drawers ---------- */
function openScrim(){$("#scrim").classList.add("on");document.body.style.overflow="hidden";}
function closeAll(){
 $("#scrim").classList.remove("on");
 $("#drawer").classList.remove("on");
 $("#mnav").classList.remove("on");
 $("#search").classList.remove("on");
 document.body.style.overflow="";
}
function openDrawer(mode){
 drawerMode=mode||"cart";
 $("#drTitle").textContent=drawerMode==="cart"?"Your cart":"Your wishlist";
 $("#drFoot").style.display=drawerMode==="cart"?"block":"none";
 renderDrawer();
 $("#drawer").classList.add("on");openScrim();
}
function cartCountN(){return shopifyCart?shopifyCart.item_count:0;}
function cartTotal(){return shopifyCart?shopifyCart.total_price/100:0;}
function renderBadges(){
 var c=cartCountN(),cc=$("#cartCount");cc.textContent=c;cc.classList.toggle("hide",c===0);
 var w=0;for(var k in wish){if(wish[k])w++;}
 var wc=$("#wishCount");wc.textContent=w;wc.classList.toggle("hide",w===0);
}
function cartLineName(l){return l.fragId?byId(l.fragId).name:l.title;}
function cartLineImage(l){
 if(!l.fragId)return "";
 var p=byId(l.fragId);
 return '<img src="'+esc(imgUrl(l.fragId))+'" alt="BuiltByThree '+esc(p.name)+' 50ml extrait de parfum bottle" width="'+esc(p.iw)+'" height="'+esc(p.ih)+'" loading="lazy">';
}
function renderSingle(l){
 var finalP=l.finalLinePrice/100,origP=l.originalLinePrice/100;
 var h='<div class="line">'+cartLineImage(l);
 h+='<div><div class="l-name">'+esc(cartLineName(l))+'</div>'+(l.fragId?'<div class="l-sub">50ml · Extrait</div>':'');
 h+='<span class="qty"><button data-qminus="'+esc(l.key)+'" aria-label="Decrease">−</button><output>'+esc(l.qty)+'</output><button data-qplus="'+esc(l.key)+'" aria-label="Increase">+</button></span></div>';
 h+='<div class="l-end"><span class="price">'+esc(money(finalP))+(finalP<origP?' <s style="opacity:.5">'+esc(money(origP))+'</s>':'')+'</span><br><button class="rm" data-remove="'+esc(l.key)+'">Remove</button></div></div>';
 return h;
}
function renderDrawer(){
 var body=$("#drBody"),h="";
 if(drawerMode==="cart"){
  var any=false;
  var lines=cartLinesInfo();
  var duoGroups={},duoOrder=[];
  var singles=[];
  lines.forEach(function(l){
   if(l.duoGroup){
    if(!duoGroups[l.duoGroup]){duoGroups[l.duoGroup]=[];duoOrder.push(l.duoGroup);}
    duoGroups[l.duoGroup].push(l);
   }else{singles.push(l);}
  });
  singles.forEach(function(l){
   any=true;h+=renderSingle(l);
  });
  duoOrder.forEach(function(gid){
   var grp=duoGroups[gid];
   any=true;
   if(grp.length===1){h+=renderSingle(grp[0]);return;}
   var names=[],members="",realPence=0,originalPence=0,count=0,allFragrances=true,standardDuo=grp.length===2;
   grp.forEach(function(l){
    names.push(cartLineName(l));
    realPence+=l.finalLinePrice;originalPence+=l.originalLinePrice;count+=l.qty;
    if(!l.fragId)allFragrances=false;
    if(!l.fragId||l.qty!==1)standardDuo=false;
    members+='<div class="l-sub">'+esc(cartLineName(l))+' × '+esc(l.qty)+' · '+esc(money(l.finalLinePrice/100))+'</div>';
   });
   h+='<div class="line">'+cartLineImage(grp[0]);
   h+='<div><div class="l-name">'+esc(names.join(" + "))+' — Duo</div><div class="l-sub">'+esc(count)+(allFragrances?' × 50ml · Extrait':' items')+'</div>'+(standardDuo?'':members)+'</div>';
   h+='<div class="l-end"><span class="price">'+esc(money(realPence/100))+(realPence<originalPence?' <s style="opacity:.5">'+esc(money(originalPence/100))+'</s>':'')+'</span><br><button class="rm" data-remove-duo="'+esc(gid)+'">Remove</button></div></div>';
  });
  if(!any){h=CHECKOUT_ENABLED
   ?'<div class="empty">Your cart is empty.<br><br><a class="link-line" href="#best" data-goto="best">Shop the City Series</a></div>'
   :'<div class="empty">Ordering opens Saturday 17 October.<br><br><a class="link-line" href="#join" data-goto="join">Join early access</a></div>';}
  body.innerHTML=h;
  var st=cartTotal();
  $("#subTotal").textContent=money(st);
  $("#shipBar").parentElement.style.display="none"; /* flat-rate shipping: no free-delivery progress bar */
  $("#shipLbl").textContent="UK delivery — £2.99 flat rate on every order.";
  $("#checkoutBtn").disabled=st===0;
  var nud=$("#cartNudge");
  if(nud)nud.style.display="none";
 }else{
  var anyw=false;
  for(var w in wish){
   if(!wish[w])continue;anyw=true;var pw=byId(w);
   h+='<div class="line">'+bottleSVG();
   h+='<div><div class="l-name">'+pw.name+'</div><div class="l-sub">'+pw.plain+'</div></div>';
   h+='<div class="l-end"><span class="price">'+money(pw.price)+'</span><br><button class="rm" data-add="'+w+'">'+buyLabel("Add to cart")+'</button></div></div>';
  }
  if(!anyw){h='<div class="empty">Nothing saved yet.<br>Tap the heart on any fragrance.</div>';}
  body.innerHTML=h;
  var nud2=$("#cartNudge");if(nud2)nud2.style.display="none";
 }
}
function launchNotice(){
 toast(LAUNCH_MSG);
 if($("#viewProduct").classList.contains("active")){goHome("join");}else{closeAll();var el=document.getElementById("join");if(el)el.scrollIntoView({behavior:"smooth"});}
}
function addToCart(id,q){
 if(!CHECKOUT_ENABLED){launchNotice();return;}
 q=q||1;
 cartAddItems([{id:byId(id).v50,quantity:q}]).then(function(){
  renderBadges();openDrawer("cart");
  toast(byId(id).name+" added to cart");
 }).catch(function(err){toast(err.message||"Could not add to cart");});
}
function addDuoToCart(idA,idB){
 if(!CHECKOUT_ENABLED){launchNotice();return;}
 var gid="duo-"+Date.now();
 cartAddItems([
  {id:byId(idA).v50,quantity:1,properties:{_duo:gid}},
  {id:byId(idB).v50,quantity:1,properties:{_duo:gid}}
 ]).then(function(){
  renderBadges();openDrawer("cart");
  toast(byId(idA).name+" + "+byId(idB).name+" duo added to cart");
 }).catch(function(err){toast(err.message||"Could not add duo");});
}

/* ---------- scent finder ---------- */
var fState=null;
function fRender(){
 var box=$("#finderBox"),h="";
 if(!fState){
  h+='<p class="f-step">Question 01 / 02</p><h3 class="f-q">Who is it for?</h3>';
  h+='<div class="f-opts">';
  h+='<button class="f-opt" data-f1="For him">For him<em>Rio or Milano</em></button>';
  h+='<button class="f-opt" data-f1="For her">For her<em>Paname or Havana</em></button>';
  h+='<button class="f-opt" data-f1="The Reserve">Go all out<em>The Reserve: Monaco or Casablanca</em></button>';
  h+='</div>';
 }else if(!fState.pick){
  var o=[];
  if(fState.cat==="For him"){o=[["rio","Bright citrus","Zesty, fresh, uplifting"],["milano","Clean everyday","Fresh, polished, all day"]];}
  else if(fState.cat==="For her"){o=[["paname","Warm vanilla","Sweet, creamy, indulgent"],["havana","Juicy fruits","Berries, playful, floral"]];}
  else{o=[["monaco","Deep oud","Dark, deep, opulent"],["casablanca","Cake gourmand","Warm, golden, sweet"]];}
  h+='<p class="f-step">Question 02 / 02</p><h3 class="f-q">Pick your mood.</h3><div class="f-opts">';
  for(var i=0;i<o.length;i++){h+='<button class="f-opt" data-f2="'+o[i][0]+'">'+o[i][1]+'<em>'+o[i][2]+'</em></button>';}
  h+='</div><button class="f-back" data-fback>← Back</button>';
 }else{
  var p=byId(fState.pick);
  h+='<p class="f-step">Your city</p>';
  h+='<div class="f-res">'+bottleSVG();
  h+='<div><p class="coords">'+p.coords+'</p><h3>'+p.name+'</h3><p class="fam">'+p.plain+'</p>';
  h+='<span class="price">'+money(p.price)+'</span>';
  h+='<div class="row"><button class="btn btn-inv" data-add="'+p.id+'">'+buyLabel("Add to cart")+'</button><button class="btn btn-ghost" data-open="'+p.id+'">View '+p.name+'</button></div>';
  h+='</div></div><button class="f-back" data-fback>← Start again</button>';
 }
 box.innerHTML=h;
}
fRender();

/* ---------- product page ---------- */
function openProduct(id){
 if($("#viewHome").classList.contains("active")){homeScrollY=window.scrollY;}
 var p=byId(id);current=p;qty=1;$("#qOut").textContent="1";
 $("#crumbCat").textContent=p.cat;
 $("#crumbName").textContent=p.name;
 $("#pCoords").textContent=p.coords;
 $("#pName").textContent=p.name;
 $("#pFamily").textContent=p.family;
 $("#pFam").textContent=p.plain;
 $("#pChips").innerHTML='<span class="chip">'+p.cat+'</span><span class="chip">50ml</span><span class="chip">Extrait strength</span>';
 $("#pDesc").textContent=p.desc;
 $("#pStory").textContent=p.story;
 var oh="";for(var j=0;j<p.occ.length;j++){oh+='<span>'+p.occ[j]+'</span>';}
 $("#pOcc").innerHTML=oh;
 $("#pPrice").textContent=money(p.price);
 $("#nTop").textContent=p.top;$("#nHeart").textContent=p.heart;$("#nBase").textContent=p.base;
 $("#pWish").classList.toggle("on",!!wish[p.id]);
 galArr=[
  '<img src="'+imgUrl(p.id)+'" alt="BuiltByThree '+p.name+' 50ml extrait de parfum bottle" width="'+p.iw+'" height="'+p.ih+'">',
  '<img src="'+img2Url()+'" alt="BuiltByThree bottle with gift box and gift bag" width="1004" height="821" loading="lazy">'
 ];
 galIx=0;
 $("#galMain").innerHTML=galArr[0];
 var thumbsH="";
 for(var gi=0;gi<galArr.length;gi++){
  thumbsH+='<button class="thumb'+(gi===0?" on":"")+'" type="button" data-thumb="'+gi+'" aria-label="Show image '+(gi+1)+' of '+p.name+'">'+galArr[gi]+'</button>';
 }
 $("#galThumbs").innerHTML=thumbsH;
 /* pairs well with */
 var other=byId(PAIRS[p.id]),tier=duoTier(p.id,other.id),was=duoWas(p.id,other.id);
 $("#fbtA").innerHTML='<img src="'+imgUrl(p.id)+'" alt="BuiltByThree '+p.name+' 50ml extrait de parfum bottle" width="'+p.iw+'" height="'+p.ih+'" loading="lazy"><div><b>'+p.name+'</b><span>'+money(p.price)+'</span></div>';
 $("#fbtB").innerHTML='<img src="'+imgUrl(other.id)+'" alt="BuiltByThree '+other.name+' 50ml extrait de parfum bottle" width="'+other.iw+'" height="'+other.ih+'" loading="lazy"><div><b>'+other.name+'</b><span>'+money(other.price)+'</span></div>';
 $("#fbtPrice").innerHTML='<s>'+money(was)+'</s> '+money(tier.price);
 $("#fbtSave").textContent="You save £"+tier.save;
 $("#fbtAdd").setAttribute("data-fbt",p.id+","+other.id);
 /* related */
 var rel=P.filter(function(x){return x.id!==p.id;}).slice(0,3);
 renderGrid($("#relGrid"),rel);
 /* recent */
 if(recent.indexOf(p.id)===-1){recent.unshift(p.id);}
 var rec=recent.filter(function(x){return x!==p.id;}).slice(0,3).map(byId);
 $("#recentWrap").style.display=rec.length?"block":"none";
 if(rec.length){renderGrid($("#recentGrid"),rec);}
 /* sticky */
 $("#sName").textContent=p.name;
 $("#sPrice").textContent=money(p.price);
 /* switch view */
 $("#viewHome").classList.remove("active");
 $("#viewProduct").classList.add("active");
 closeAll();
 window.scrollTo({top:0,behavior:"auto"});
 document.title=p.name+": BuiltByThree";
}
function goHome(target,filter){
 $("#viewProduct").classList.remove("active");
 $("#viewHome").classList.add("active");
 $("#stickyBar").classList.remove("show");
 document.title="BuiltByThree: Extrait de Parfum · Six Cities";
 closeAll();
 if(filter){applyFilter(filter);}
 if(target){setTimeout(function(){var el=document.getElementById(target);if(el)el.scrollIntoView({behavior:"smooth"});},60);}
 else{window.scrollTo({top:homeScrollY,behavior:"auto"});}
}

/* ---------- gallery swipe (touch) ---------- */
(function(){
 var startX=null;
 var gm=$("#galMain");
 if(!gm)return;
 gm.addEventListener("touchstart",function(e){startX=e.touches[0].clientX;},{passive:true});
 gm.addEventListener("touchend",function(e){
  if(startX===null||galArr.length<2)return;
  var dx=e.changedTouches[0].clientX-startX;
  startX=null;
  if(Math.abs(dx)<40)return;
  galIx=dx<0?Math.min(galIx+1,galArr.length-1):Math.max(galIx-1,0);
  $("#galMain").innerHTML=galArr[galIx];
  $all(".thumb").forEach(function(x,i){x.classList.toggle("on",i===galIx);});
 },{passive:true});
})();

/* ---------- duo builder ---------- */
function renderDuoCards(){
 var h="";
 for(var i=0;i<P.length;i++){
  var p=P[i],sel=duoSel.indexOf(p.id)>-1;
  h+='<button class="duo-card'+(sel?" on":"")+'" type="button" data-duo="'+p.id+'" aria-pressed="'+sel+'">';
  h+='<img src="'+imgUrl(p.id)+'" alt="BuiltByThree '+p.name+' 50ml extrait de parfum bottle" width="'+p.iw+'" height="'+p.ih+'" loading="lazy">';
  h+='<span class="duo-card-name">'+p.name+'</span><span class="duo-card-price">'+money(p.price)+'</span>';
  h+='</button>';
 }
 $("#duoCards").innerHTML=h;
}
function renderDuoPanel(){
 var countEl=$("#duoCount"),box=$("#duoPriceBox"),btn=$("#duoAdd"),reason=$("#duoReason");
 countEl.textContent=duoSel.length+" of 2 selected";
 if(duoSel.length===2){
  var tier=duoTier(duoSel[0],duoSel[1]),was=duoWas(duoSel[0],duoSel[1]);
  box.innerHTML='<span class="price">'+money(tier.price)+'</span> <s>'+money(was)+'</s> <span class="duo-save">You save £'+tier.save+'</span>';
  btn.disabled=false;
  reason.textContent="";
 }else{
  box.innerHTML="";
  btn.disabled=true;
  reason.textContent=duoSel.length===0?"Select 2 fragrances to build your duo.":"Select 1 more fragrance to build your duo.";
 }
}
function toggleDuo(id){
 var ix=duoSel.indexOf(id);
 if(ix>-1){duoSel.splice(ix,1);}
 else{
  duoSel.push(id);
  if(duoSel.length>2){duoSel.shift();}
 }
 renderDuoCards();renderDuoPanel();
}
renderDuoCards();renderDuoPanel();

/* ---------- sticky ATC ---------- */
var buyBox=$("#buyBox");
if("IntersectionObserver" in window){
 new IntersectionObserver(function(entries){
  var vis=$("#viewProduct").classList.contains("active");
  $("#stickyBar").classList.toggle("show",vis&&!entries[0].isIntersecting);
 },{rootMargin:"-80px 0px 0px 0px"}).observe(buyBox);
}

/* ---------- reveal on scroll ---------- */
var io=null;
if("IntersectionObserver" in window){
 io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add("in");io.unobserve(e.target);}});},{threshold:.12});
 $all(".reveal").forEach(function(el){io.observe(el);});
}else{$all(".reveal").forEach(function(el){el.classList.add("in");});}

/* ---------- search ---------- */
function renderSearch(q){
 q=(q||"").toLowerCase();var h="",n=0;
 for(var i=0;i<P.length;i++){
  var p=P[i],hay=(p.name+" "+p.plain+" "+p.cat+" "+p.top+" "+p.heart+" "+p.base+" "+p.occ.join(" ")).toLowerCase();
  if(!q||hay.indexOf(q)>-1){h+='<a href="#" data-open="'+p.id+'"><span class="s-row"><img src="'+imgUrl(p.id)+'" alt="BuiltByThree '+p.name+' 50ml extrait de parfum bottle" width="'+p.iw+'" height="'+p.ih+'" loading="lazy">'+p.name+': '+p.plain+'</span><span>'+money(p.price)+'</span></a>';n++;}
 }
 if(!n){h='<a href="#" data-goto="best">No match. View the full collection<span></span></a>';}
 $("#sResults").innerHTML=h;
}

/* ---------- events ---------- */
document.addEventListener("click",function(e){
 var t=e.target.closest("[data-add],[data-open],[data-wish],[data-goto],[data-home],[data-cat],[data-remove],[data-remove-duo],[data-qplus],[data-qminus],[data-thumb],[data-fbt],[data-filter],[data-f1],[data-f2],[data-fback],[data-duo],.acc-btn");
 if(!t)return;
 if(t.hasAttribute("data-add")){e.preventDefault();addToCart(t.getAttribute("data-add"),1);return;}
 if(t.hasAttribute("data-fbt")){e.preventDefault();var ids=t.getAttribute("data-fbt").split(",");addDuoToCart(ids[0],ids[1]);return;}
 if(t.hasAttribute("data-remove-duo")){
  e.preventDefault();
  var gid=t.getAttribute("data-remove-duo");
  var grpLines=cartLinesInfo().filter(function(l){return l.duoGroup===gid;});
  var updates={};
  grpLines.forEach(function(l){updates[l.key]=0;});
  cartUpdateKeys(updates).then(function(){renderBadges();renderDrawer();}).catch(function(err){toast(err.message||"Could not remove duo");});
  return;
 }
 if(t.hasAttribute("data-duo")){e.preventDefault();toggleDuo(t.getAttribute("data-duo"));return;}
 if(t.hasAttribute("data-open")){e.preventDefault();openProduct(t.getAttribute("data-open"));return;}
 if(t.hasAttribute("data-wish")){
  e.preventDefault();var id=t.getAttribute("data-wish");wish[id]=!wish[id];
  $all('[data-wish="'+id+'"]').forEach(function(b){b.classList.toggle("on",wish[id]);});
  renderBadges();toast(wish[id]?byId(id).name+" saved to wishlist":byId(id).name+" removed from wishlist");
  if($("#drawer").classList.contains("on")&&drawerMode==="wish")renderDrawer();
  return;
 }
 if(t.hasAttribute("data-home")){e.preventDefault();goHome();return;}
 if(t.hasAttribute("data-cat")){e.preventDefault();var cf=t.getAttribute("data-cat");if($("#viewProduct").classList.contains("active")){goHome("best",cf);}else{applyFilter(cf);closeAll();var be=document.getElementById("best");if(be)be.scrollIntoView({behavior:"smooth"});}return;}
 if(t.hasAttribute("data-goto")){e.preventDefault();var g=t.getAttribute("data-goto");if($("#viewProduct").classList.contains("active")){goHome(g);}else{closeAll();var el=document.getElementById(g);if(el)el.scrollIntoView({behavior:"smooth"});}return;}
 if(t.hasAttribute("data-remove")){
  e.preventDefault();
  cartChangeByKey(t.getAttribute("data-remove"),0).then(function(){renderBadges();renderDrawer();}).catch(function(err){toast(err.message||"Could not remove item");});
  return;
 }
 if(t.hasAttribute("data-qplus")){
  e.preventDefault();
  var k1=t.getAttribute("data-qplus");
  var line1=cartLinesInfo().filter(function(l){return l.key===k1;})[0];
  if(!line1)return;
  cartChangeByKey(k1,line1.qty+1).then(function(){renderBadges();renderDrawer();}).catch(function(err){toast(err.message||"Could not update quantity");});
  return;
 }
 if(t.hasAttribute("data-qminus")){
  e.preventDefault();
  var k2=t.getAttribute("data-qminus");
  var line2=cartLinesInfo().filter(function(l){return l.key===k2;})[0];
  if(!line2)return;
  cartChangeByKey(k2,Math.max(0,line2.qty-1)).then(function(){renderBadges();renderDrawer();}).catch(function(err){toast(err.message||"Could not update quantity");});
  return;
 }
 if(t.hasAttribute("data-thumb")){var ix=+t.getAttribute("data-thumb");galIx=ix;$("#galMain").innerHTML=galArr[ix];$all(".thumb").forEach(function(x){x.classList.remove("on");});t.classList.add("on");return;}
 if(t.hasAttribute("data-filter")){applyFilter(t.getAttribute("data-filter"));return;}
 if(t.hasAttribute("data-f1")){fState={cat:t.getAttribute("data-f1"),pick:null};fRender();return;}
 if(t.hasAttribute("data-f2")){fState.pick=t.getAttribute("data-f2");fRender();return;}
 if(t.hasAttribute("data-fback")){fState=fState&&fState.pick?{cat:fState.cat,pick:null}:null;fRender();return;}
 if(t.classList.contains("acc-btn")){var acc=t.parentElement;acc.classList.toggle("open");t.setAttribute("aria-expanded",acc.classList.contains("open")?"true":"false");return;}
});

$("#qPlus").addEventListener("click",function(){qty++;$("#qOut").textContent=qty;});
$("#qMinus").addEventListener("click",function(){if(qty>1)qty--;$("#qOut").textContent=qty;});
$("#pAdd").addEventListener("click",function(){if(current)addToCart(current.id,qty);});
$("#sAdd").addEventListener("click",function(){if(current)addToCart(current.id,1);});
$("#pWish").addEventListener("click",function(){if(!current)return;var id=current.id;wish[id]=!wish[id];this.classList.toggle("on",wish[id]);$all('[data-wish="'+id+'"]').forEach(function(b){b.classList.toggle("on",wish[id]);});renderBadges();toast(wish[id]?current.name+" saved to wishlist":current.name+" removed from wishlist");});
$("#duoAdd").addEventListener("click",function(){if(duoSel.length!==2)return;addDuoToCart(duoSel[0],duoSel[1]);duoSel=[];renderDuoCards();renderDuoPanel();});

$("#cartBtn").addEventListener("click",function(){openDrawer("cart");});
$("#wishBtn").addEventListener("click",function(){openDrawer("wish");});
$("#drClose").addEventListener("click",closeAll);
$("#scrim").addEventListener("click",closeAll);
$("#burgerBtn").addEventListener("click",function(){$("#mnav").classList.add("on");openScrim();});
$("#mnavClose").addEventListener("click",closeAll);
$("#searchBtn").addEventListener("click",function(){$("#search").classList.add("on");openScrim();renderSearch("");setTimeout(function(){$("#searchInput").focus();},80);});
$("#searchInput").addEventListener("input",function(){renderSearch(this.value);});
document.addEventListener("keydown",function(e){if(e.key==="Escape")closeAll();});

/* buy-button labels that live in the Liquid markup follow the launch switch too */
$("#pAdd").textContent=buyLabel("Add to cart");
$("#sAdd").textContent=buyLabel("Add to cart");
$("#fbtAdd").textContent=buyLabel("Add both to cart");
$("#duoAdd").textContent=buyLabel("Add duo to cart","Duo opens 17 Oct");
$("#checkoutBtn").textContent=buyLabel("Checkout","Checkout opens at launch");
$("#checkoutNote").textContent=CHECKOUT_ENABLED?"Secure checkout · UK delivery £2.99 flat rate":"Ordering opens Saturday 17 October";
$("#checkoutBtn").addEventListener("click",function(){
 if(CHECKOUT_ENABLED){window.location.href="/checkout";return;}
 launchNotice();
});

/* nav overlay: transparent over the hero, solid once scrolled past it */
var heroSec=document.querySelector(".hero"),navBar=document.querySelector(".nav-overlay");
if(heroSec&&navBar){
 function checkNavOverlay(){
  var navH=navBar.offsetHeight;
  if(heroSec.getBoundingClientRect().bottom<=navH){navBar.classList.add("nav-solid");}
  else{navBar.classList.remove("nav-solid");}
 }
 checkNavOverlay();
 window.addEventListener("scroll",checkNavOverlay,{passive:true});
}

cartFetch().then(function(){
 renderBadges();
 if(drawerMode==="cart"&&$("#drawer").classList.contains("on"))renderDrawer();
}).catch(function(e){console.error("initial cart fetch failed",e);renderBadges();});

/* deep links: /?p=rio or /#rio opens that product (used by /products/<handle> redirects); /?cart=1 opens the cart;
   /?search=1&q=… opens the search overlay (used by the /search redirect);
   /#best (used by /collections/* redirects) or any other section id scrolls there once the page has loaded */
(function(){
 var qs=new URLSearchParams(window.location.search);
 var hash=window.location.hash.replace("#","");
 var want=qs.get("p")||hash;
 for(var i=0;i<P.length;i++){if(P[i].id===want){openProduct(want);return;}}
 if(qs.get("cart")==="1"){openDrawer("cart");return;}
 if(qs.get("search")==="1"){var term=qs.get("q")||"";$("#search").classList.add("on");openScrim();$("#searchInput").value=term;renderSearch(term);return;}
 if(hash&&document.getElementById(hash)){
  var go=function(){setTimeout(function(){var el=document.getElementById(hash);if(el)el.scrollIntoView({behavior:"instant",block:"start"});},60);};
  if(document.readyState==="complete"){go();}else{window.addEventListener("load",go);}
 }
})();
})();
